import PosthogService from '~/services/posthog/PosthogService';

export function fireMenuBarInboxClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:inbox_clicked');
}
